var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoMenuBets = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.998,
    viewBox: "0 0 18 17.998",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_48619",
    "data-name": "Path 48619",
    transform: "translate(-112.287 -432.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48516",
    "data-name": "Path 48516",
    d: "M130.275,444.741c0-2.061-1.608-3.392-3.163-4.68a15.948,15.948,0,0,1-2.08-1.937.51.51,0,0,0-.39-.182h-.034a.509.509,0,0,0-.393.185,16.188,16.188,0,0,1-2.079,1.934c-1.556,1.287-3.166,2.617-3.166,4.68a3.029,3.029,0,0,0,2.872,3.175h.279a3.173,3.173,0,0,0,1.911-.769,12.32,12.32,0,0,1-1.334,3.172,10.978,10.978,0,0,1,3.849,0,12.442,12.442,0,0,1-1.33-3.17,3.16,3.16,0,0,0,1.907.767h.144a3.027,3.027,0,0,0,3.007-2.9C130.279,444.928,130.279,444.835,130.275,444.741Z",
    transform: "translate(.01)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43667",
    "data-name": "Group 43667",
    transform: "translate(112.288 432.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48517",
    "data-name": "Path 48517",
    d: "M118.453,446.867a4.439,4.439,0,0,1-.469-3.109c.448-1.9,2.119-3.31,3.517-4.465l.012-.01.015-.012c.3-.23.58-.478.861-.732l-1.7-1.215v-2.257h0l2.555-1.408.012-.007a7.312,7.312,0,0,1,2.214,1.493c.093.093.184.187.271.283v.012l-.341,1.708a1.517,1.517,0,0,1,.4.317,15.013,15.013,0,0,0,1.942,1.807l.013.009.012.01c.186.154.375.312.563.472a7.966,7.966,0,0,0-8-7.442,8.059,8.059,0,0,0-6.673,3.5,7.782,7.782,0,0,0-1.363,4.409,7.972,7.972,0,0,0,7.289,7.867,7.488,7.488,0,0,1-1.124-1.23Zm-3.566-11.44c.087-.1.177-.189.27-.281h0a7.278,7.278,0,0,1,2.213-1.493l.012.007,2.555,1.407v2.262l-2.169,1.552-.128.091-2.185-.707-.258-1.294-.308-1.527Zm-.967,8.22H113.9a6.491,6.491,0,0,1-.309-.632,7.013,7.013,0,0,1-.538-2.088l.011-.008,2.161-1.955,2.112.684.878,2.656-1.38,1.771Z",
    transform: "translate(-112.288 -432.321)",
    fill: "#999"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoMenuBets);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_menu_bets.a52227296f4cae7659c7ed83d998c454.svg";